export default __webpack_public_path__ + "effa864a0e6aa66d5bb444752689cb16.png";